export const WAVE_EDITOR = 'wave-editor';
export const EMBED_INTERNAL_PARAM = 'internal';
